import { render, staticRenderFns } from "./TitleAndBreadcrumb.vue?vue&type=template&id=2fcaed8b&scoped=true&lang=pug&"
import script from "./TitleAndBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TitleAndBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcaed8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
